import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

const PhotoSlideshow = () => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  
  const photos = [
    '/photo_1a.JPG',
    '/photo_2.jpeg',
    '/photo_3.jpeg',
    '/photo_4.jpeg',
    '/photo_5.JPG',
    '/photo_6.JPG'
  ];

  return (
    <div className="w-full px-4 pt-8 pb-12 md:pt-16 md:pb-16">
      {/* Title */}
      <div className="text-center mb-8 animate-fade-in">
        <h1 className="font-serif text-4xl md:text-6xl mb-2 tracking-tight text-christmas-green">
          Merry Christmas
        </h1>
        <p className="text-christmas-red text-sm md:text-base tracking-widest uppercase">
          December 25, 2025
        </p>
      </div>

      {/* Photo Container with Swiper */}
      <div className="relative w-full max-w-2xl mx-auto">
        {/* Artsy Frame */}
        <div className="relative p-4 md:p-6 bg-gradient-to-br from-gray-50 to-white border-2 border-christmas-green shadow-[8px_8px_0px_0px_rgba(10,61,46,1)]">
          <div className="relative w-full aspect-[3/4] md:aspect-[4/3] overflow-hidden bg-black">
            <Swiper
              ref={swiperRef}
              modules={[Autoplay, EffectFade]}
              effect="fade"
              fadeEffect={{
                crossFade: true
              }}
              speed={600}
              autoplay={{
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
              }}
              loop={true}
              className="w-full h-full"
              grabCursor={true}
              touchRatio={1}
              threshold={5}
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            >
              {photos.map((photo, index) => (
                <SwiperSlide key={index}>
                  <div className="w-full h-full bg-white">
                    <img
                      src={photo}
                      alt={`Memory ${index + 1}`}
                      className="w-full h-full object-cover"
                      loading={index === 0 ? 'eager' : 'lazy'}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>

        {/* Navigation Dots */}
        <div className="flex justify-center gap-3 mt-6">
          {photos.map((_, index) => (
            <button
              key={index}
              onClick={() => swiperRef.current?.swiper?.slideToLoop(index)}
              className={`w-2 h-2 transition-all duration-300 ${
                activeIndex === index
                  ? 'bg-christmas-red w-8'
                  : 'bg-gray-600 hover:bg-gray-400'
              }`}
              aria-label={`Go to photo ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PhotoSlideshow;
